import classNames from 'classnames'
import RcTooltip from 'rc-tooltip'

import type { ReactElement, ReactNode } from 'react'

import './tooltip.scss'

type Alignment = {
  // align top left point of sourceNode with top right point of targetNode
  offset?: number[]
  // the offset targetNode by 30% of targetNode width in x and 40% of targetNode height in y,
  overflow?: {
    adjustX: boolean
    adjustY: boolean
  }
  points?: string[]
  // the offset sourceNode by 10px in x and 20px in y,
  targetOffset?: number[]
}

type Placement = 'left' | 'right' | 'top' | 'bottom' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight'

type Trigger = 'hover' | 'click' | 'focus'

interface Props {
  align?: Alignment
  children: ReactElement
  className?: string
  destroyOnHide?: boolean
  mouseEnterDelay?: number
  noPadding?: boolean
  overlay: ReactNode
  overlayClassName?: string
  placement: Placement
  trigger: Trigger | Trigger[]
}

const Tooltip = ({
  align,
  children,
  className,
  destroyOnHide = false,
  mouseEnterDelay,
  noPadding = false,
  overlay,
  overlayClassName,
  placement,
  trigger,
}: Props): ReactElement => {
  const overlayClasses = classNames('tooltip-content', { 'no-padding': noPadding }, className)

  return (
    <RcTooltip
      align={align}
      destroyTooltipOnHide={destroyOnHide}
      mouseEnterDelay={mouseEnterDelay}
      overlay={<div className={overlayClasses}>{overlay}</div>}
      overlayClassName={overlayClassName}
      placement={placement}
      trigger={trigger}
    >
      {children}
    </RcTooltip>
  )
}

export default Tooltip
